/**
 * Admin Dashboard formatting helpers (pure functions).
 */

export function scoreColor(score: number | null) {
  if (score === null) return 'text-gray-400';
  if (score >= 80) return 'text-emerald-500 dark:text-emerald-400';
  if (score >= 60) return 'text-amber-500 dark:text-amber-400';
  return 'text-red-500 dark:text-red-400';
}

export function scoreBg(score: number | null) {
  if (score === null) return 'bg-gray-100 dark:bg-gray-800';
  if (score >= 80) return 'bg-emerald-50 dark:bg-emerald-900/20';
  if (score >= 60) return 'bg-amber-50 dark:bg-amber-900/20';
  return 'bg-red-50 dark:bg-red-900/20';
}

export function gradeColor(grade: string | null) {
  if (!grade) return 'text-gray-400';
  const map: Record<string, string> = {
    A: 'text-emerald-500',
    B: 'text-blue-500',
    C: 'text-amber-500',
    D: 'text-orange-500',
  };
  return map[grade] ?? 'text-red-500';
}

export function formatDate(d: string | null) {
  if (!d) return '—';
  return new Date(d).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
